import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { smTitle } from '@ifca-root/react-component/src/global/TitleVariable'
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize'
import ShareIcon from '@material-ui/icons/Share'
import { Pagination } from '@material-ui/lab'
import { Group, drawDOM, exportPDF } from '@progress/kendo-drawing'
import ShareDialog from 'components/Dialog/ShareDialog'
import saveAs from 'file-saver'
import {
  useGetCompanyQuery,
  useGetCostCentreQuery,
  useGetShareAttachmentMutation,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import { useMobilePDFZoom } from 'helpers/Hooks/useMobilePDFZoom'
import * as htmlToImage from 'html-to-image'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import './OR.scss'
import './PDFStyle.scss'
import { useGLQueries } from './Query/useGLQueries'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import ELetterPreview from 'containers/ARModule/Hooks/ELetterTemplate/ELetterPreview'

export const PDFPreviewGLV2 = (props: any) => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location: any = useLocation()
  const journalDetail: any = location?.state
  const { accountType, docType } = props
  let history = useHistory()
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [isDataHandled, setIsDataHandled] = useState<boolean>(false)
  const [pageLength, setPageLength] = useState(1)

  const { styles } = useMobilePDFZoom()

  const {
    CompanyID,
    JournalProcessingID,
    RecurringJournalID,
    AuditAdjustmentID,
  }: any = useParams()

  const {
    loading: companyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getCompany }) => {
      setLabelState(getCompany[0]?.Name)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const {
    loading: CostCentreLoading,
    data: { getCostCentre } = { getCostCentre: [] },
  } = useGetCostCentreQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  let routeSegments
  let title
  let smallTitle
  let name
  let DocumentID
  let itemName

  smallTitle = smTitle.GENERAL_LEDGER

  switch (docType) {
    case 'journal-processing':
      DocumentID = JournalProcessingID
      routeSegments = 'Journal Entries'
      title = 'JOURNAL VOUCHER'
      itemName = 'JournalProcessingItem'
      break
    case 'recurring-journal':
      DocumentID = RecurringJournalID
      routeSegments = 'Recurring Journal Entries'
      title = 'RECURRING JOURNAL'
      itemName = 'RecurringJournalItem'
      break
    case 'audit-adjustment':
      DocumentID = AuditAdjustmentID
      routeSegments = 'Audit Adjustment Entries'
      title = 'AUDIT ADJUSTMENT JOURNAL'
      itemName = 'AuditAdjustmentItem'
      break
  }

  const {
    loading,
    listData,
    templateBody,
    errMessage: errMsg,
    errDialog: errDia,
    setErrDialog: setErrDia,
  } = useGLQueries({
    accountType,
    docType,
    CompanyID,
    TransactionID: DocumentID,
  })

  const previewDetail: any = {
    ...listData[0],
    itemList: listData[0]?.[itemName],
    [itemName]: [],
  }

  const [width] = useMediaQuery()

  // ========== Page definition ==========
  const [page, setCurrentPage] = useState<number>(0)

  // ========== Threshold definition ==========
  let totalItems = previewDetail?.[itemName]?.length

  let threshold
  if (totalItems > 15) {
    threshold = 15
  } else {
    threshold = 0
  }

  // ========== Remap Data for item list ==========
  const [remapData, setRemapData] = useState(null)

  // const separateThreshold = input => {
  //   let temp = []
  //   let noChange = []
  //   let tempItem = []

  //   previewDetail?.[itemName]?.map((v, i) => {
  //     tempItem.push({ ...v, index: i + 1 })
  //     if ((i + 1) % threshold === 0) {
  //       temp.push({ ...input, [itemName]: tempItem })
  //       tempItem = []
  //     } else if (previewDetail?.[itemName]?.length === i + 1) {
  //       temp.push({ ...input, [itemName]: tempItem })
  //     }
  //   })
  //   noChange.push(temp)
  //   temp = []
  //   return setRemapData(noChange.flat())
  // }

  /// ========== kendo-drawing PDF Download ===========
  const dataURItoFile = (dataurl, filename) => {
    dataurl.replace('data:application/pdf;base64,', '')
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  const onPrint = () => {
    let element = document.getElementById('pdf-data-print')

    drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })
      .then((group: Group) => exportPDF(group))
      .then(dataURI => {
        let fileObject = dataURItoFile(
          dataURI,
          `${title} (${previewDetail?.DocNo}).pdf`
        )
        saveAs(fileObject, `${title} (${previewDetail?.DocNo}).pdf`)
      })
  }

  const onShare = async (filename = 'document.pdf') => {
    const element = document.getElementById('pdf-data-print')

    const group = await drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })

    const dataURI = await exportPDF(group)

    // Convert Base64 → Blob
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = 'application/pdf'
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    const blob = new Blob([ab], { type: mimeString })

    // ✅ Return a File object with PDF type
    const file = new File([blob], filename, { type: mimeString })
    return file
  }

  const [labelState, setLabelState] = useState<string>()

  const [openShareDialog, setOpenShareDialog] = useState(false)
  const [openSendEmail, setOpenSendEmail] = useState(false)

  const [
    getShareAttachments,
    {
      data: { getShareAttachment } = { getShareAttachment: {} as any },
      called: getShareAttachmentCalled,
      loading: ShareAttachmentLoading,
    },
  ] = useGetShareAttachmentMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenShareDialog(true)
    },
  })

  const onSubmit = blob => {
    getShareAttachments({
      variables: {
        file: blob,
        CompanyID: CompanyID,
      },
    })
  }

  const pdfToPrint = () => {
    return (
      <>
        {/* ========================================= */}
        {/* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */}
        {/* ========================================= */}
        <div style={{ position: 'fixed', left: `-2000px` }}>
          <div id={'pdf-data-print'}>
            <ELetterPreview
              title={title}
              previewDetail={previewDetail}
              itemName={itemName}
              accountType={accountType}
              docType={docType}
              getCostCentre={getCostCentre}
              getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
              listData={listData}
              remapData={remapData}
              page={page}
              pageLength={pageLength}
              currencyCode={user?.companyCurrencyCode}
              htmlTemplate={templateBody}
              threshold={threshold}
            />
          </div>
        </div>
      </>
    )
  }

  const footerOptions = [
    {
      name: 'Share',
      onClick: async () => {
        // let temp = await document.getElementById('pdf-data-print')
        // temp.querySelectorAll('img').forEach(img => {
        //   img.setAttribute('crossorigin', 'anonymous')
        // })

        // htmlToImage
        //   .toBlob(temp, { style: { background: '#fff' } })
        //   .then(value => {
        //     onSubmit(value)
        //   })
        //   .catch(error => console.error(error, 'Something went wrong'))
        onSubmit(await onShare())
      },
      color: 'primary',
      props: { type: 'submit' },
      startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
    },
    {
      name: 'Download',
      color: 'primary',
      onClick: () => {
        onPrint()
      },
    },
  ]

  return (
    <>
      {loading && <Loading />}
      {UserLoading && <Loading />}
      {companyLoading && <Loading />}
      {CostCentreLoading && <Loading />}
      {ShareAttachmentLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (previewDetail?.ApprovalStatus === 'COMPLETED') {
            history.push({
              pathname: `/${accountType}/${CompanyID}/${docType}/${DocumentID}/detail`,
              state: previewDetail,
            })
          } else {
            history.push({
              pathname: `/${accountType}/${CompanyID}/${docType}`,
              state: previewDetail,
            })
          }
        }}
        smTitle={smallTitle}
        title={getCompany[0]?.Name}
        routeSegments={[
          { name: `${smTitle}` },
          { name: `${routeSegments}` },
          { name: `${routeSegments}`, current: true },
        ]}
        rightRouteSegments={[{ name: 'Print', current: true }]}
      />

      <ContentWrapper footer>
        {/* ============================== */}
        {/* DISPLAYED IN HTML TO BE VIEWED */}
        {/* ============================== */}
        <div style={{ height: window.screen.height }}>
          <div style={styles.supercontainer}>
            <div style={styles.container}>
              <ELetterPreview
                title={title}
                previewDetail={previewDetail}
                itemName={itemName}
                accountType={accountType}
                docType={docType}
                getCostCentre={getCostCentre}
                getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                listData={listData}
                remapData={remapData}
                page={page}
                pageLength={pageLength}
                currencyCode={user?.companyCurrencyCode}
                htmlTemplate={templateBody}
                threshold={threshold}
              />
            </div>
          </div>
        </div>

        <div
          className={
            width < 769 ? 'pagination-dis-mobile' : 'pagination-dis-desktop'
          }
        >
          <Pagination
            count={remapData?.length}
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1)
            }}
          />
        </div>
      </ContentWrapper>
      <ShareDialog
        shareTitle={`General Ledger - ${labelState}`}
        title="Share"
        URL={getShareAttachment?.fileURL}
        setSimple={setOpenShareDialog}
        simple={openShareDialog}
        emailShare={openSendEmail}
        setSimpleEmail={setOpenSendEmail}
      />
      <Footer options={footerOptions} />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />

      <div style={{ width: 1980 }}>{pdfToPrint()}</div>
    </>
  )
}
